// Azzurro "Spot the Slip" expansion — aggregator.
//
// Collects every per-theme `CORRECTIONS_<THEME>` module into a single flat array
// of [ wrong, right, tag, why, slug ] tuples. ./corrections.js appends these to
// its base ROWS before mapping to the structured CORRECTIONS shape the practice
// view consumes, so ids stay sequential and the new items flow through unchanged.
//
// Every tag used by these modules already exists in CORRECTION_TAGS (essere-stare,
// preposition, articulated-prep, gender, agreement, piacere, passato-imperfetto,
// pronoun-order, congiuntivo, auxiliary, ci-ne, article, plural, negation), so no
// new filter chips are required.

import { CORRECTIONS_IDENTITY } from "./corrections-identity.js";
import { CORRECTIONS_FAMILY } from "./corrections-family.js";
import { CORRECTIONS_HOUSE } from "./corrections-house.js";
import { CORRECTIONS_FOOD } from "./corrections-food.js";
import { CORRECTIONS_BODY_HEALTH } from "./corrections-body-health.js";
import { CORRECTIONS_DAILY_ROUTINE } from "./corrections-daily-routine.js";
import { CORRECTIONS_WORK_STUDY } from "./corrections-work-study.js";
import { CORRECTIONS_TRAVEL } from "./corrections-travel.js";
import { CORRECTIONS_TIME_WEATHER } from "./corrections-time-weather.js";
import { CORRECTIONS_SHOPPING } from "./corrections-shopping.js";
import { CORRECTIONS_TOWN } from "./corrections-town.js";
import { CORRECTIONS_LEISURE } from "./corrections-leisure.js";
import { CORRECTIONS_FEELINGS } from "./corrections-feelings.js";
import { CORRECTIONS_NATURE } from "./corrections-nature.js";
import { CORRECTIONS_DESCRIBING } from "./corrections-describing.js";
import { CORRECTIONS_SCIENCE_TECH } from "./corrections-science-tech.js";
import { CORRECTIONS_POLITICS } from "./corrections-politics.js";
import { CORRECTIONS_MEDIA } from "./corrections-media.js";

// Order mirrors the 18 canonical themes.
export const EXTRA_CORRECTION_ROWS = [
  ...CORRECTIONS_IDENTITY,
  ...CORRECTIONS_FAMILY,
  ...CORRECTIONS_HOUSE,
  ...CORRECTIONS_FOOD,
  ...CORRECTIONS_BODY_HEALTH,
  ...CORRECTIONS_DAILY_ROUTINE,
  ...CORRECTIONS_WORK_STUDY,
  ...CORRECTIONS_TRAVEL,
  ...CORRECTIONS_TIME_WEATHER,
  ...CORRECTIONS_SHOPPING,
  ...CORRECTIONS_TOWN,
  ...CORRECTIONS_LEISURE,
  ...CORRECTIONS_FEELINGS,
  ...CORRECTIONS_NATURE,
  ...CORRECTIONS_DESCRIBING,
  ...CORRECTIONS_SCIENCE_TECH,
  ...CORRECTIONS_POLITICS,
  ...CORRECTIONS_MEDIA,
];
